export function scrollToBottom(el) {
  if (!el) return
  el.scrollTop = el.scrollHeight
}

export function anchorMessageToTop(container, target, offset = 0) {
  if (!container || !target) return
  const delta = target.getBoundingClientRect().top - container.getBoundingClientRect().top
  container.scrollTop += delta - offset
}

export function nextScrollAction(prev, messages) {
  const count = messages.length
  const last = count ? messages[count - 1] : null
  const lastId = last ? last.id : null
  const next = { count, lastId }

  if (lastId === prev.lastId) return { action: 'none', anchorUserId: null, next }

  if (count === prev.count + 1 && last.role === 'assistant') {
    for (let i = count - 1; i >= 0; i--) {
      if (messages[i].role === 'user') return { action: 'anchor', anchorUserId: messages[i].id, next }
    }
  }
  return { action: 'bottom', anchorUserId: null, next }
}
